import S3 from "aws-sdk/clients/s3.js";

const s3 = new S3({
  endpoint: `https://ed1fb0af83a83ca59c749ddffd118906.r2.cloudflarestorage.com`,
  accessKeyId: process.env.REACT_APP_ACCESSKEYID,
  secretAccessKey: process.env.REACT_APP_SECRETACCESSKEY,
  signatureVersion: "v4",
});
export default s3;
